import { IconCloseRound } from 'components/Icons';
import { Concept } from 'api/grpc/resources';
import { removeTag, tag } from 'components/ConceptSelector/styles';

interface ConceptTagProps {
  concept: Concept;
  onRemoveTag: () => void;
}

export const ConceptTags = ({ concept, onRemoveTag }: ConceptTagProps): JSX.Element => {
  return (
    <div className={tag} data-testid={`${concept.getName()}-concept-tag`}>
      <span>{concept.getName()}</span>
      <IconCloseRound className={removeTag} size={14} color="#306AFF" onClick={onRemoveTag} aria-label={`remove-tag-${concept.getName()}`} />
    </div>
  );
};
